enum FolderNameValidationResult {
  Good = 'good',
  Empty = 'empty',
  TooLong = 'long',
  InvalidCharacters = 'invalid',
  Blacklisted = 'blacklist',
}

export const MAX_TITLE_LENGTH = 50;
// the following is based on the backend logic, we should try to keep
// it in sync
function isValidFolderName(input: string, blacklistedNames: string[] = []) {
  const name = input.trim();
  if (!name || !name.length) {
    return FolderNameValidationResult.Empty;
  }

  if (name.length > MAX_TITLE_LENGTH) {
    return FolderNameValidationResult.TooLong;
  }

  if (!/^[ \w$?:.,'"\-+]+$/.test(name)) {
    return FolderNameValidationResult.InvalidCharacters;
  }

  if (
    [
      'favourites',
      'featured',
      ...blacklistedNames.map(n => n.toLowerCase()),
    ].includes(name.toLowerCase())
  ) {
    return FolderNameValidationResult.Blacklisted;
  }

  return FolderNameValidationResult.Good;
}

export function getFolderNameValidationErrorMessage(
  name: string,
  t: Function,
  blacklistedNames: string[] = [],
  isGallery: boolean
) {
  const result = isValidFolderName(name, blacklistedNames);
  switch (result) {
    case FolderNameValidationResult.Empty:
      return t('collectionPanel.error.emptyName');
    case FolderNameValidationResult.TooLong:
      return t('collectionPanel.error.longName');
    case FolderNameValidationResult.InvalidCharacters:
      return t('collectionPanel.error.invalidCharacters');
    case FolderNameValidationResult.Blacklisted:
      if (isGallery) {
        return t('collectionPanel.error.blacklisted.gallery', { name });
      }
      return t('collectionPanel.error.blacklisted.collection', { name });
    default:
      return;
  }
}
